var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.586752 7.33675L6.83675 1.08675C7.01287 0.910634 7.25174 0.81169 7.50082 0.81169C7.74989 0.81169 7.98876 0.910634 8.16488 1.08675C8.341 1.26287 8.43994 1.50175 8.43994 1.75082C8.43994 1.99989 8.341 2.23876 8.16488 2.41488L2.57816 8.00003L8.16332 13.5868C8.25052 13.674 8.3197 13.7775 8.36689 13.8914C8.41409 14.0054 8.43838 14.1275 8.43838 14.2508C8.43838 14.3741 8.41409 14.4963 8.36689 14.6102C8.3197 14.7241 8.25052 14.8277 8.16332 14.9149C8.07611 15.0021 7.97258 15.0713 7.85864 15.1185C7.7447 15.1657 7.62258 15.1899 7.49925 15.1899C7.37592 15.1899 7.2538 15.1656 7.13986 15.1185C7.02592 15.0713 6.9224 15.0021 6.83519 14.9149L0.58519 8.66488C0.497892 8.57768 0.428666 8.4741 0.381483 8.36009C0.334299 8.24608 0.310086 8.12388 0.310231 8.00049C0.310376 7.8771 0.334878 7.75496 0.382329 7.64106C0.429781 7.52716 0.499249 7.42375 0.586752 7.33675Z",
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSide);
export default __webpack_public_path__ + "static/media/leftSide.dd0eff7ef857d48ed5d01378ec55acb1.svg";
export { ForwardRef as ReactComponent };